import {
  Flex,
  PrimaryButton,
  SecondaryButton,
  SystemProps,
  Text,
} from "flicket-ui";
import { useRouter } from "next/router";
import React, { ElementType, FC, useContext } from "react";
import { UserContext } from "~context";

type RenewalBannerProps = SystemProps & {
  button: "primary" | "secondary";
};

export const RenewalBanner: FC<RenewalBannerProps> = (props) => {
  const router = useRouter();
  const { user } = useContext(UserContext);

  const handleClick = () => {
    void router.push("/members-area?open=true");
  };

  let Button: ElementType;
  if (props.button === "primary") {
    Button = PrimaryButton;
  } else {
    Button = SecondaryButton;
  }

  return (
    <Flex
      flexDir={{ md: "row", _: "column" }}
      width="100%"
      border={"2px"}
      borderColor="N100"
      padding={2}
      justifyContent="space-between"
      borderRadius={"md"}
      alignItems="center"
      {...props}
    >
      <Flex flexDir={"column"}>
        <Text fontWeight={"heavy"} fontSize={{ _: 5 }} color={"N800"}>
          {user.firstName}, you can now renew your membership for the upcoming
          season.
        </Text>
        <Text
          mt={{ _: 2, md: 1 }}
          fontSize={4}
          mb={{ _: 3, md: 0 }}
          color={"N800"}
        >
          Your previous seats will be held for a limited time before they are
          released back to the public.
        </Text>
      </Flex>
      <Button shadow={"button"} height={46} onClick={() => handleClick()}>
        Renew my membership
      </Button>
    </Flex>
  );
};
